import axios from 'axios';
import type { ContactType } from '~/generated/prisma';

/**
 * Interface for contact filters
 */
export interface ContactFilters {
  page?: number;
  limit?: number;
  type?: ContactType;
  verified?: boolean;
  search?: string;
  taskId?: string;
}

/**
 * Fetch paginated contacts from the API
 *
 * @param filters - Optional filters for contacts
 * @returns Paginated contacts response
 */
export const getContactsApi = async (
  filters: ContactFilters = {},
): Promise<PaginationResponse<ContactWithTask>> => {
  const params = new URLSearchParams();

  if (filters.page) params.append('page', filters.page.toString());
  if (filters.limit) params.append('limit', filters.limit.toString());
  if (filters.type) params.append('type', filters.type);
  if (filters.verified !== undefined)
    params.append('verified', filters.verified.toString());
  if (filters.search) params.append('search', filters.search);
  if (filters.taskId) params.append('taskId', filters.taskId);

  const response = await axios.get<{
    success: boolean;
    contacts: PaginationResponse<ContactWithTask>;
  }>(`/api/contacts?${params.toString()}`);
  return response.data.contacts;
};

/**
 * Fetch contact statistics from the API
 *
 * @returns Contact statistics
 */
export const getContactStatsApi = async (): Promise<ContactStats> => {
  const response = await axios.get<{ stats: ContactStats }>(
    '/api/contacts/stats',
  );
  return response.data.stats;
};
